/**
 * ObstructionAttachments
 *
 * "Attachments" section of the obstruction details panel. Read-only list of the
 * obstruction's file attachments, delegating to the shared, source-agnostic
 * `AttachmentsViewer` (list + inline preview + download).
 */
import { memo, useMemo } from 'react';

import { AttachmentsViewer } from '@/components/common/AttachmentsViewer';
import { obstructionAttachmentsToPreviewable } from '@/utils/attachmentDownload';
import type { Obstruction } from '@/types/obstructions';

interface ObstructionAttachmentsProps {
  obstruction: Obstruction;
}

export const ObstructionAttachments = memo(function ObstructionAttachments({
  obstruction,
}: ObstructionAttachmentsProps) {
  const previewableAttachments = useMemo(
    () => obstructionAttachmentsToPreviewable(obstruction.attachments),
    [obstruction.attachments]
  );

  return <AttachmentsViewer attachments={previewableAttachments} />;
});
